module.exports = __webpack_public_path__ + "img/upper_arm.0c36667a.png";